import { useMemo } from 'react';
import { useQueries } from '@tanstack/react-query';
import { isBefore } from 'date-fns';
import { useStoreActions } from "../../../contexts.ts";
import { useFeatureFlags } from "../../useFeatureFlags.ts";
import { serviceModel } from "../../../models/index.ts";
import { toDateStampObject } from "../../../models/time/translator.ts";
import { QueryKeys } from "../queryKeys.ts";
export const useServicesBillingDetails = _ref => {
  let {
    services,
    relationshipEffectiveDate,
    enabled = true
  } = _ref;
  const {
    START_BILLING_AT,
    START_BILLING_AT_PHASE_2_INLINE
  } = useFeatureFlags();
  const startBillingAtEnabled = enabled && (START_BILLING_AT || START_BILLING_AT_PHASE_2_INLINE);
  const {
    api
  } = useStoreActions();
  const servicesWithStartBilling = useMemo(() => {
    if (!startBillingAtEnabled) return [];
    return services.filter(service => {
      const startBillingAt = serviceModel.startBillingAt(service);
      if (startBillingAt) {
        return relationshipEffectiveDate ? !isBefore(startBillingAt, relationshipEffectiveDate) : true;
      }
    });
  }, [services, startBillingAtEnabled, relationshipEffectiveDate]);
  const billingPeriodsQueries = useQueries({
    queries: servicesWithStartBilling.map(service => {
      const serviceDTO = serviceModel.toDTO(service);
      return {
        queryKey: [QueryKeys.ServiceBillingDetails, serviceDTO],
        queryFn: () => {
          return api.relationship.serviceBillingDetails(serviceDTO, relationshipEffectiveDate ? toDateStampObject(relationshipEffectiveDate) : undefined);
        },
        select: data => ({
          serviceId: service.id,
          data
        }),
        cacheTime: 0,
        enabled: startBillingAtEnabled
      };
    })
  });
  const servicesBillingDetails = useMemo(() => {
    return Object.fromEntries(billingPeriodsQueries.filter(_ref2 => {
      let {
        data
      } = _ref2;
      return !!data;
    }).map(_ref3 => {
      let {
        data
      } = _ref3;
      return [data === null || data === void 0 ? void 0 : data.serviceId, data === null || data === void 0 ? void 0 : data.data];
    }));
  }, [billingPeriodsQueries]);
  const isLoading = startBillingAtEnabled && billingPeriodsQueries.some(query => query.isInitialLoading);
  const isFetching = startBillingAtEnabled && billingPeriodsQueries.some(query => query.isFetching);
  return {
    servicesBillingDetails,
    isLoading,
    isFetching
  };
};